import { type EnvironmentId } from "@t3tools/contracts";
import { Trans } from "@lingui/react/macro";
import { FilesIcon } from "lucide-react";

import { Button } from "../ui/button";
import { useDocumentsPanelStore } from "../../documentsPanelStore";

export function DocumentsHeaderButton({
  environmentId,
  projectCwd,
}: {
  environmentId: EnvironmentId;
  projectCwd: string;
}) {
  const openPanel = useDocumentsPanelStore((state) => state.openPanel);
  return (
    <Button
      variant="outline"
      size="xs"
      className="shrink-0 gap-1"
      onClick={() => openPanel({ environmentId, projectCwd })}
    >
      <FilesIcon className="size-3" />
      <Trans>Documents</Trans>
    </Button>
  );
}
